"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceType = exports.PaymentMethod = exports.BundleType = void 0;
var BundleType;
(function (BundleType) {
    BundleType["SWAG"] = "swag";
    BundleType["SENDOSO"] = "sendoso";
    BundleType["POSTAL"] = "postal";
    BundleType["DYNAMIC"] = "dynamic";
})(BundleType = exports.BundleType || (exports.BundleType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "creditCard";
    PaymentMethod["DUMMY_PAYMENT"] = "dummyPayment";
    PaymentMethod["NET_15"] = "NET_15";
    PaymentMethod["NET_30"] = "NET_30";
    PaymentMethod["NET_45"] = "NET_45";
    PaymentMethod["NET_60"] = "NET_60";
    PaymentMethod["UPFR_50_NET_15"] = "UPFR_50_NET_15";
    PaymentMethod["UPFR_50_NET_30"] = "UPFR_50_NET_30";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["CREDITS"] = "inventoryCredits";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["ORDER"] = "order";
    InvoiceType["QUOTE"] = "quote";
    InvoiceType["DISTRIBUTION"] = "distribution";
    InvoiceType["CREDITS"] = "credits";
})(InvoiceType = exports.InvoiceType || (exports.InvoiceType = {}));
